'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'icons';
var width = 512;
var height = 512;
var aliases = ["heart-music-camera-bolt"];
var unicode = 'f86d';
var svgPathData = ['M48 72.6c0 6.8 2.8 13.3 7.8 17.9L128 158.2l72.2-67.7c5-4.6 7.8-11.1 7.8-17.9c0-13-11.1-24.6-25.3-24.6c-7 0-13.7 2.8-18.3 7.5l-2.5 2.5L128 91.9 94.1 57.9l-2.5-2.5C86.9 50.8 80.2 48 73.3 48C59.1 48 48 59.6 48 72.6zM48 336l0 128 192 0 0-128-16 0-29.7 0-13.3-26.5-2.7-5.5-68.7 0-2.7 5.5L93.7 336 64 336l-16 0zm144 56a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z', 'M125.5 21.5C111.7 7.7 92.8 0 73.3 0C33.2 0 0 32.5 0 72.6c0 20.1 8.3 39.2 22.9 52.9L128 224l105.1-98.5C247.7 111.8 256 92.6 256 72.6C256 32.5 222.8 0 182.7 0c-19.5 0-38.5 7.7-52.3 21.5L128 24l-2.5-2.5zM128 158.2L55.8 90.5c-5-4.6-7.8-11.1-7.8-17.9C48 59.6 59.1 48 73.3 48c7 0 13.7 2.8 18.3 7.5l33.7-33.7L91.6 55.5l2.5 2.5L128 91.9l33.9-33.9 2.5-2.5c4.6-4.6 11.4-7.5 18.3-7.5C196.9 48 208 59.6 208 72.6c0 6.8-2.8 13.3-7.8 17.9L128 158.2zM224 288l-16-32L80 256 64 288l-16 0L0 288l0 48L0 464l0 48 48 0 192 0 48 0 0-48 0-128 0-48-48 0-16 0zm16 48l0 128L48 464l0-128 16 0 29.7 0 13.3-26.5 2.7-5.5 68.7 0 2.7 5.5L194.3 336l29.7 0 16 0zm-48 56a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM457.1 256L320 400l72.2 10.5L374.9 512 512 368l-72.2-10.5L457.1 256zM288 256c35.3 0 64-21.5 64-48l0-124.3L464 61.3l0 68.2c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48l0-144 0-29.3L483.3 8.5l-160 32L304 44.3 304 64l0 97.5c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faIcons = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;